import { useState } from 'react';
import { timePeriodTypes } from '../../../utility/types/TimePeriodTypes';

export const TIME_SELECTOR_HOURS = 'Hours';
export const TIME_SELECTOR_MINUTES = 'Minutes';
export const DEFAULT_TIME_PERIOD_TYPE_ID = timePeriodTypes.MON;
export const DEFAULT_TIME_PART_HOURS_OR_MINUTES = 0;
export const defaultTimePeriod = {
  startTimePeriodTypeId: DEFAULT_TIME_PERIOD_TYPE_ID,
  startHours: DEFAULT_TIME_PART_HOURS_OR_MINUTES,
  startMinutes: DEFAULT_TIME_PART_HOURS_OR_MINUTES,
  endTimePeriodTypeId: DEFAULT_TIME_PERIOD_TYPE_ID,
  endHours: DEFAULT_TIME_PART_HOURS_OR_MINUTES,
  endMinutes: DEFAULT_TIME_PART_HOURS_OR_MINUTES,
};
const useQuietTimes = ({ initialQuietTime }) => {
  const [quietTime, setQuietTime] = useState(initialQuietTime);

  const updateQuietTime = (name, value) => {
    setQuietTime({
      ...quietTime,
      [name]: value,
    });
  };

  return {
    quietTime,
    updateQuietTime,
  };
};
export default useQuietTimes;
